import React, { useState } from 'react';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  actions as uiActions,
} from '../../../ducks/ui/ui.index';
import {
  actions as incidentActions
} from '../../../ducks/incident/incident.index';
import { Modal, Button, Form, Tooltip, OverlayTrigger, Row } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import {Formik, Field} from 'formik';
import moment from 'moment-timezone';
/* ========= PACKAGE IMPORTS ========= */

const mapStateToProps = ({uiState, userState, incidentState}) => ({
  pageLoading         : uiState.pageLoading,
  authorization       : userState.user.authorization,
});
const mapDispatchToProps =  (dispatch) => {
  const combinedActionCreators = {
    setPageLoading           :  uiActions.setPageLoading,
    submitUpdateIncident     :  incidentActions.submitUpdateIncident,
  };

  return bindActionCreators(combinedActionCreators, dispatch);
};

const UpdateIncidentModal = ({ incidentDetails, submitUpdateIncident, setPageLoading, authorization }) => {
  const intermediateNextSendDate = incidentDetails.next_send_date == 0 || incidentDetails.next_send_date === null ? new Date() : new Date(incidentDetails.next_send_date);
  const [nextSendDate, setNextSendDate] = useState(intermediateNextSendDate);
  const jira_id = incidentDetails.jira_id;
  const priority_type = incidentDetails.priority_type;
  
  // SNIPPET FROM: https://stackoverflow.com/questions/71646357/force-react-datepicker-to-use-utc
  const { timeZone: localTZ } = Intl.DateTimeFormat().resolvedOptions()
  // The TZ format I want everything to be displayed and submitted as
  const apiTZ = 'utc'

  let styles = {
    clickableLink  :  {
      cursor    :  'pointer',
      color     :  'blue',
    },
    error  :  {
      color     :  'red',
    },
    button        : {
      width       :  '8rem',
    },
    buttonRight   : {
      width       : '8rem',
      marginLeft  : '5px'
    },
    buttonError  :  {
      color     :  'red',
      marginRight:  '5px',
    },
    infoImg: {
      maxHeight : '1.9rem',
    },
    inlineMiddleVAlign: {
      display : 'inline',
      verticalAlign : 'middle'
    },
  }
  let buttonMessage = '';
  const [modalIsOpen,setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  }
  const closeModal = () => {
    setIsOpen(false);
  }

  const displayButton = (values, errors) => {
    let displayButton = true;
    buttonMessage = '';
    if (values.next_send_date === nextSendDate ){
      displayButton = false;
      buttonMessage = 'Must Change A Value';
    }
    return displayButton;
  }

  const submitForm = () => {

    const form_payload = {jira_id : jira_id, next_send_date : nextSendDate, priority_type : priority_type}
    setPageLoading(true);
    submitUpdateIncident(form_payload);
    closeModal();
    return true;
  };

  const submitClearNextSendDate = () => {
    const form_payload = {jira_id : jira_id, next_send_date : null, priority_type : priority_type}
    submitUpdateIncident(form_payload);
    closeModal();
    return true;
  }

  return (
    <div>
      <OverlayTrigger
        key='left'
        placement='left'
        overlay={
        <Tooltip id={`tooltip-left`}>
          Update SLA Next Send Date
        </Tooltip>
      }
      >
      <div style={styles.clickableLink} onClick={openModal} className={"data-cy-update-incident-button-" + jira_id}>Update</div>
      </OverlayTrigger>

      
      <Modal show={modalIsOpen} onHide={closeModal} className="data-cy-update-incident-modal">
        <Formik
            onSubmit={submitForm}
            initialValues={{
              next_send_date: nextSendDate,
              jira_id: jira_id
            }}
        >
        {({
          handleSubmit,
          values,
          errors,
        }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Update Next Send Date for {jira_id}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group>
                  <Form.Label>Next Send Date (UTC)</Form.Label>
                  <DatePicker
                    onChange = {(date) => {
                      const apiTimeFromPickerLocalDate = moment(date)
                      .tz(localTZ)
                      // change TZ without changing date/time
                      .tz(apiTZ, true)
                      .format()
                      setNextSendDate(apiTimeFromPickerLocalDate)
                    }}
                    selected={
                      moment(nextSendDate)
                        .tz(apiTZ)
                        // Display picker time in local TZ without changing date/time
                        .tz(localTZ, true)
                        .toDate()
                    }
                    showTimeInput       = "true"
                    dateFormat          = "Pp"
                    style               = {{width: '100%'}}
                    required
                    />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Row>
                  <div style={styles.buttonError}>{buttonMessage}</div>
                  <Button style={styles.button} variant="secondary" className="data-cy-update-incident-modal-close" onClick={closeModal}>Cancel</Button>
                  <Button style={styles.buttonRight} className="data-cy-update-incident-modal-clear-send-date" onClick={submitClearNextSendDate}>Clear Send Date</Button>
                  <Button style={styles.buttonRight} className="data-cy-update-incident-modal-submit" type="submit">Update</Button>
                  
                </Row>
              </Modal.Footer>
            </Form>
          )}
          </Formik>
      </Modal>
    </div>
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(UpdateIncidentModal);